"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

var _scrollbar = _interopRequireDefault(require("../../style/scrollbar"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props) {
  var palette = theme.palette,
      maxListLength = props.maxListLength,
      scrollStyle = (0, _scrollbar["default"])(palette);
  var lineHeight = null,
      countedMaxHeight = null;

  if (typeof theme.itemLineHeight === 'number') {
    lineHeight = (0, _pixelToNumber["default"])(theme.itemFontSize) * theme.itemLineHeight;
  } else if (typeof theme.itemLineHeight === 'string') {
    lineHeight = (0, _pixelToNumber["default"])(theme.itemLineHeight);
  }

  countedMaxHeight = maxListLength * (lineHeight + palette.gutter * 2);
  return {
    root: {
      position: 'relative',
      width: theme.width,
      minWidth: theme.minWidth
    },
    list: _objectSpread({
      // like popup
      zIndex: palette.zOverlay,
      background: theme.listBackground,
      padding: "".concat(palette.gutter, "px 0"),
      border: "1px solid ".concat(theme.listBorderColor),
      boxShadow: theme.listBoxShadow,
      overflowX: 'hidden',
      overflowY: 'auto',
      top: 'calc(100% + 3px)',
      left: 0,
      width: '100%',
      maxHeight: "".concat(countedMaxHeight, "px"),
      boxSizing: 'content-box'
    }, scrollStyle),
    item: {
      display: 'block',
      fontSize: theme.itemFontSize,
      lineHeight: theme.itemLineHeight,
      color: theme.itemColor,
      width: '100%',
      whiteSpace: 'nowrap',
      backgroundColor: 'transparent',
      border: '0 none',
      fontFamily: theme.fontFamily,
      margin: 0,
      textAlign: 'left',
      padding: "".concat(palette.gutter, "px ").concat(palette.gutter * 2, "px"),
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      outline: '0 none',
      '&:hover': {
        cursor: 'pointer',
        background: theme.hoverItemBackground,
        outline: '0 none'
      },
      '&:focus': {
        cursor: 'pointer',
        background: theme.focusItemBackground,
        outline: '0 none'
      },
      '&:active': {
        cursor: 'pointer',
        background: theme.activeItemBackground,
        outline: '0 none'
      },
      '&.focused': {
        cursor: 'pointer',
        background: theme.focusItemBackground,
        outline: '0 none'
      }
    },
    input: {
      width: '100%'
    }
  };
}